export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-1.dc178c0e.png";